import styled, { css } from 'styled-components';

import { recipesCommonAction, styledReset, styledTypography } from '@pkg/primitives';

// TODO: Cannot use `CommonAction` until it supports more <Link /> props.
export const StyledCartButton = styled.button<{ $forceInline?: boolean }>`
    ${styledReset.button};
    ${recipesCommonAction.blur};
    gap: 8px;
    width: 40px;
    height: 40px;

    svg {
        width: 22px;
        color: currentColor;
    }

    @media (max-width: 767px) {
        position: absolute;
        top: 24px;
        right: 24px;
    }

    ${({ $forceInline }) =>
        $forceInline &&
        css`
            @media (max-width: 767px) {
                position: relative;
                top: unset;
                right: unset;
            }
        `}
`;

export const NoticePip = styled.span`
    ${styledTypography.allianceBase};

    position: absolute;
    top: -6px;
    right: -6px;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 16px;
    height: 16px;

    font-size: 10px;
    font-weight: 700;

    background-color: #ff0000;
    border-radius: 100%;
`;
